import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    FUNNEL_ADDRESS_STEP,
    FUNNEL_PAYMENT_SELECTION_STEP,
    FUNNEL_PAYMENT_PROCESSING_STEP
} from '../../constants/funnel';

import { mergeQueryLocked } from '../../utils/ebonUtils';

import FunnelAddressStep from './address-step/FunnelAddressStep';
import FunnelPaymentStep from './payment-step/FunnelPaymentStep';
import FunnelPaymentSelectionStep from './payment-selection-step/FunnelPaymentSelectionStep';
import FunnelFraudVerificationStep from './fraud-verification-step/FunnelFraudVerificationStep';

import './FunnelLeftContainerStyle.scss';

const FunnelLeftContainer = ({
    partnerId,
    userInfo,
    setUserInfo,
    paymentType,
    setPaymentType,
    cartTotalValue,
    stateOfTransaction,
    setStateOfTransaction,
    setModalData,
    merchantCardPath,
    kycNeeded,
    setKycNeeded,
    ebon,
    lock
}) => {
    // Handle lock response
    useEffect(() => {
        if (!isEmpty(lock)) {
            const { allLocked } = lock;
            if (!allLocked) {
                delete lock.allLocked;
                const final = mergeQueryLocked(ebon.cart, lock);
                return setModalData(final);
            } else {
                setStateOfTransaction(FUNNEL_PAYMENT_SELECTION_STEP);
            }
        }
    }, [lock]);

    return (
        <div id="funnel-left-container">
            {stateOfTransaction === FUNNEL_ADDRESS_STEP && (
                <FunnelAddressStep
                    partnerId={partnerId}
                    setUserInfo={setUserInfo}
                    merchantCardPath={merchantCardPath}
                />
            )}

            <FunnelFraudVerificationStep
                partnerId={partnerId}
                userInfo={userInfo}
                kycNeeded={kycNeeded}
                setKycNeeded={setKycNeeded}
            />

            <div className="leftInnerContainer">
                {stateOfTransaction === FUNNEL_PAYMENT_SELECTION_STEP && (
                    <FunnelPaymentSelectionStep
                        userInfo={userInfo}
                        partnerId={partnerId}
                        setPaymentType={setPaymentType}
                        cartTotalValue={cartTotalValue}
                        kycNeeded={kycNeeded}
                        setStateOfTransaction={setStateOfTransaction}
                    />
                )}

                {stateOfTransaction === FUNNEL_PAYMENT_PROCESSING_STEP && (
                    <FunnelPaymentStep
                        userInfo={userInfo}
                        partnerId={partnerId}
                        paymentType={paymentType}
                    />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        ebon: state.ebon,
        lock: state.ebon.lock
    };
};

FunnelLeftContainer.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object,
    setUserInfo: PropTypes.func,
    paymentType: PropTypes.string,
    setPaymentType: PropTypes.func,
    cartTotalValue: PropTypes.number,
    stateOfTransaction: PropTypes.string,
    setStateOfTransaction: PropTypes.func,
    setModalData: PropTypes.func,
    merchantCardPath: PropTypes.string,
    kycNeeded: PropTypes.bool,
    setKycNeeded: PropTypes.func
};

export default connect(mapStateToProps)(FunnelLeftContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/FunnelLeftContainer.js